import '../../sass/layout/page/page-contact.scss';

const contactForm=document.querySelector('#contactForm');
if(contactForm){
    contactForm.addEventListener('submit', e=>{
        e.preventDefault();
        xajax_exe('PageModule-xajaxContact', xajax.getFormValues('contactForm'));
        setTimeout(() => {
            window.onclick = function(event) {
                if (event.target == document.querySelector(`[data-modal='message']`)) {
                    document.querySelector(`[data-modal='message']`).style.display = "none";
                }
            }
            document.querySelector(`[data-modal='message'] .close`).onclick = function() {
                document.querySelector(`[data-modal='message']`).style.display = "none";
            }
        }, 1000)
    });
}

var map = null;
var markers = [];
var point=[parseFloat(document.getElementById("map").dataset.lat), parseFloat(document.getElementById("map").dataset.long)];

var posInfo = new google.maps.Size(155, 235);

var icon = {
    url: location.protocol + '//' + location.host + '/templates/gfx/marker_map.png'
};


var mapOptions = {
    center: {
        lat: point[0],
        lng: point[1]
    },
    zoom: 12,
    styles: [
        {
            "featureType": "all",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-88"
                }
            ]
        }
    ]
}

var activeMarker = null;
map = new google.maps.Map(document.getElementById("map"), mapOptions);

var marker = new google.maps.Marker({
    position: new google.maps.LatLng(point[0], point[1]),
    icon: icon,
});

markers.push(marker);
marker.setMap(map);